var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Mixins } from 'vue-property-decorator';
import devToolMixin from './devToolMixin';
import icons from './icons';
let OptionButtons = class OptionButtons extends Mixins(devToolMixin) {
  constructor() {
    super(...arguments);
    this.filterMenuVisible = false; // 全屏模式下会有问题，第一次不渲染，但是状态被改变了，可能是getContainer的bug
  }
  get currentRenderer() {
    var _this$currentScope;
    return ((_this$currentScope = this.currentScope) === null || _this$currentScope === void 0 || (_this$currentScope = _this$currentScope.list) === null || _this$currentScope === void 0 ? void 0 : _this$currentScope[this.currentScopedSlotIndex]) || this.uc.renderer;
  }
  get displayModes() {
    const h = this.$createElement;
    return ['seperate', 'bottom', 'left', 'right'].map(mode => h("img", {
      "attrs": {
        "src": icons[`${mode}Mode`]
      },
      "class": {
        active: this.displayMode === mode
      },
      "on": {
        "click": () => this.displayMode = mode
      }
    }));
  }
  get configURL() {
    var _this$windowRef, _xyWindow$xy_runtime_, _xyWindow$xy_runtime_2, _xyWindow$xy_runtime_3, _xyWindow$GLOBAL_INFO;
    const xyWindow = ((_this$windowRef = this.windowRef) === null || _this$windowRef === void 0 ? void 0 : _this$windowRef.opener) || this.windowRef.parent;
    const pageId = ((_xyWindow$xy_runtime_ = xyWindow.xy_runtime_router) === null || _xyWindow$xy_runtime_ === void 0 || (_xyWindow$xy_runtime_ = _xyWindow$xy_runtime_.currentRoute) === null || _xyWindow$xy_runtime_ === void 0 || (_xyWindow$xy_runtime_ = _xyWindow$xy_runtime_.meta) === null || _xyWindow$xy_runtime_ === void 0 ? void 0 : _xyWindow$xy_runtime_.pageId) || ((_xyWindow$xy_runtime_2 = xyWindow.xy_runtime_pages) === null || _xyWindow$xy_runtime_2 === void 0 || (_xyWindow$xy_runtime_2 = _xyWindow$xy_runtime_2[0]) === null || _xyWindow$xy_runtime_2 === void 0 ? void 0 : _xyWindow$xy_runtime_2.pageId) || '';
    const projectId = ((_xyWindow$xy_runtime_3 = xyWindow.xy_runtime_project) === null || _xyWindow$xy_runtime_3 === void 0 ? void 0 : _xyWindow$xy_runtime_3.id) || '';
    const pathPrefix = ((_xyWindow$GLOBAL_INFO = xyWindow.GLOBAL_INFO) === null || _xyWindow$GLOBAL_INFO === void 0 ? void 0 : _xyWindow$GLOBAL_INFO.pathPrefix) || '';
    if (!pageId || !projectId) {
      this.$message.error('跳转失败');
      return;
    }
    const queryParams = new URLSearchParams({
      projectid: projectId,
      pageid: pageId
    });
    return `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${pathPrefix}/xy/project/pageconfig?${queryParams.toString()}`;
  }
  handleLog() {
    var _this$currentRenderer;
    const ref = (_this$currentRenderer = this.currentRenderer) === null || _this$currentRenderer === void 0 ? void 0 : _this$currentRenderer.getRefByPath(this.activeCompPath);
    window.top.$comp = ref;
    this.messageOnDt('请打开浏览器的控制台，使用 $comp 操作组件实例');
  }
  render() {
    const h = arguments[0];
    return h("span", {
      "class": "btn-group-float ucd-devTool-iconBtns"
    }, [this.showJump ? h("a-tooltip", {
      "attrs": {
        "getPopupContainer": () => {
          var _this$windowRef2;
          return ((_this$windowRef2 = this.windowRef) === null || _this$windowRef2 === void 0 ? void 0 : _this$windowRef2.document.body) || window.document.body;
        }
      }
    }, [h("span", {
      "slot": 'title'
    }, [" \u524D\u5F80\u914D\u7F6E\u9875 "]), h("a", {
      "attrs": {
        "href": this.configURL,
        "target": "_blank"
      },
      "style": "display: inline-block; width: 100%; height: 100%;"
    }, [h("a-icon", {
      "attrs": {
        "type": "tool",
        "theme": "filled"
      }
    })])]) : null, h("a-tooltip", {
      "attrs": {
        "getPopupContainer": () => {
          var _this$windowRef3;
          return ((_this$windowRef3 = this.windowRef) === null || _this$windowRef3 === void 0 ? void 0 : _this$windowRef3.document.body) || window.document.body;
        }
      }
    }, [h("span", {
      "slot": "title"
    }, [" \u5728\u63A7\u5236\u53F0\u4E2D\u8C03\u8BD5 "]), h("a-icon", {
      "attrs": {
        "type": "bug",
        "theme": "filled"
      },
      "on": {
        "click": this.handleLog
      }
    })]), h("a-dropdown", {
      "attrs": {
        "trigger": ['click'],
        "getPopupContainer": () => {
          var _this$windowRef4;
          return ((_this$windowRef4 = this.windowRef) === null || _this$windowRef4 === void 0 ? void 0 : _this$windowRef4.document.body) || window.document.body;
        }
      },
      "model": {
        value: this.filterMenuVisible,
        callback: $$v => {
          this.filterMenuVisible = $$v;
        }
      }
    }, [h("a-icon", {
      "attrs": {
        "type": "filter",
        "theme": "filled"
      },
      "on": {
        "click": e => e.preventDefault()
      }
    }), h("a-menu", {
      "slot": "overlay"
    }, [h("a-menu-item", {
      "key": "displayMode",
      "class": "ucd-devTool-menu-item",
      "style": {
        display: 'flex',
        'justify-content': 'space-around'
      }
    }, [this.displayModes]), h("a-menu-item", {
      "key": "showDefaultProps",
      "class": "ucd-devTool-menu-item"
    }, [h("a-checkbox", {
      "attrs": {
        "checked": this.bus.options.showDefaultProps
      },
      "on": {
        "change": e => this.$set(this.bus.options, 'showDefaultProps', e.target.checked)
      }
    }, ["\u663E\u793A\u7EC4\u4EF6\u9ED8\u8BA4\u914D\u7F6E"])]), h("a-menu-divider"), h("a-menu-item", {
      "key": "darkMode",
      "class": "ucd-devTool-menu-item"
    }, [h("a-checkbox", {
      "model": {
        value: this.bus.options.darkMode,
        callback: $$v => {
          this.$set(this.bus.options, "darkMode", $$v);
        }
      }
    }, [" \u9ED1\u591C\u6A21\u5F0F "])])])])]);
  }
};
OptionButtons = __decorate([Component({
  name: 'OptionButtons'
})], OptionButtons);
export default OptionButtons;